'use client';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { usePageDirtyStore } from '@/common/store/page-dirty-store';

export default function PageDirtyMonitor() {
  const previousPathNameRef = useRef<string | null>(null);
  const pathname = usePathname();
  const clear = usePageDirtyStore((state) => state.clear);

  useEffect(() => {
    if (pathname != previousPathNameRef.current) {
      previousPathNameRef.current = pathname;
      clear();
    }
  }, [pathname, clear]);

  return null;
}
